// extracted by mini-css-extract-plugin
export default {"versionRow":"versionRow__o7DrBm","versionRowSelected":"versionRowSelected__IVLIO9","itemHeader":"itemHeader__pvrpT3","timestamp":"timestamp__P358d2","author":"author___O2Vnn"};